import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupCdicClient = () => {
  const { t } = useTranslation();

  return {
    name: Yup.string().required(
      t("validation.required", {
        name: t("page.name"),
      })
    ),
    phoneNumber: Yup.string().required(
      t("validation.required", {
        phoneNumber: t("page.phoneNumber"),
      })
    ).max(11, t("validation.max_length", { max: 11 })),
    gender: Yup.string().required(
      t("validation.required", {
        gender: t("page.gender"),
      })
    ),
    state: Yup.string().required(
      t("validation.required", {
        state: t("page.state"),
      })
    ),
    township: Yup.string().required(
      t("validation.required", {
        township: t("page.township"),
      })
    ),
    hospitalName: Yup.string().required(
      t("validation.required", {
        hospitalName: t("page.hospital_name"),
      })
    ),
    dateOfBirth: Yup.string().required(
      t("validation.required", {
        dateOfBirth: t("page.dateOfBirth"),
      })
    ),
    insulinType: Yup.string().required(
      t("validation.required", {
        insulinType: t("page.insulin_type"),
      })
    ),
    referredBy: Yup.array().required(
      t("validation.required", {
        referredBy: t("page.referredBy"),
      })
    ),
    gestational_age_of_1_st_AN_care_visit: Yup.string().required(
      t("validation.required", {
        referredBy: t("page.gestational_age_of_1_st_AN_care_visit"),
      })
    ),
    total_numbers_of_AN_care_visit: Yup.string().required(
      t("validation.required", {
        referredBy: t("page.total_numbers_of_AN_care_visit"),
      })
    ),
  };
};
